<script setup lang="ts">
import type { RangeSelection } from "lexical";

import {
  EMOJI_ORDERED_LIST,
  EMOJI_TO_KEYWORD_MAP,
  formatEmojiName,
  getEmojiWithSkinTone,
} from "~/constants/iconAndEmoji";
import type { TypeaheadGetOptionsFn, TypeaheadOption } from "~/shared/types";
import { useUserStore } from "~/stores";

import EmojiTypeaheadIcon from "./EmojiTypeaheadIcon.vue";
import TypeaheadPlugin from "./typeahead/TypeaheadPlugin.vue";

const userStore = useUserStore();

const getOptionsFns: TypeaheadGetOptionsFn[] = [
  () =>
    Promise.resolve({
      key: "emoji",
      options: EMOJI_ORDERED_LIST.map((emoji) => {
        const emojiWithSkinTone = getEmojiWithSkinTone(emoji, userStore.skinTone);
        return {
          value: emojiWithSkinTone,
          label: formatEmojiName(emoji),
          icon: EmojiTypeaheadIcon,
          iconArgs: { emoji: emojiWithSkinTone },
          adtlSearchTerms: EMOJI_TO_KEYWORD_MAP.get(emoji)?.split(" ") ?? [],
        };
      }),
      total: EMOJI_ORDERED_LIST.length,
    }),
];

const onSelect = (selection: RangeSelection, option: TypeaheadOption) => {
  if (!selection) {
    return;
  }
  selection.insertRawText(`${option.value} `);
};
</script>

<template>
  <TypeaheadPlugin trigger=":" :get-options-fns="getOptionsFns" wide @select="onSelect" />
</template>
